import React, { useContext, useEffect, useState } from "react";
import { EmpdContext } from "../../Context";
import { Document, Page, PDFDownloadLink } from "@react-pdf/renderer";
import { createUseStyles } from "react-jss";
import { pick } from 'lodash'
import classNames from "classnames";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from "../Button";
import { globalStyles } from "../../Styles";
import parse from 'html-react-parser';

interface Props {
  className?: string;
}

interface ResultProps {
	data: any;
	id: string;
}

const useStyles = createUseStyles({
  root: {},
  dataSummaryWrapper: {},
  dataSummary: {
    marginBottom: 50,
  },
  dataSummaryHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #e1e5ed",
    // "& h4": {
    //   margin: 0,
    // },
  },
  dataSummaryTypeCol: {
    flexBasis: "75%",
  },
  dataSummaryStatusCol: {
    flexBasis: "25%",
    textAlign: "right",
  },
  tableHead: {
    background: "#152E54",
    color: "#fff",
    padding: 10,
    margin: 0,
  },
  statBall: {
    width: 15,
    height: 15,
    borderRadius: "50%",
    marginRight: 10,
  },
  statCol: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "center",
  },
  control: {
    marginTop: 75,
    marginBottom: 30,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    width: "100%",
    paddingBlock: "0.75rem",
    touchAction: "none",
    userSelect: "none",
  },
  track: {
    width: "100%",
    height: "1rem",
    background:
      "linear-gradient(90deg, #3660a2, lightblue, yellow, orange, #ff6464)",
    borderRadius: "0.25rem",
    userSelect: "none",
  },
  indicator: {
    borderRadius: "0.25rem",
    userSelect: "none",
  },
  thumb: {
    marginTop: 10,
    width: "0",
    height: "0",
    borderLeft: "15px solid transparent",
    borderRight: "15px solid transparent",
    borderBottom: "35px solid #152E54",
    "& h5": {
      paddingTop: 20,
      width: 100,
      transform: "translateX(-45%)",
    },
  },
  slider: {
    width: "100%",
  },
  others: {
    width: 175,
    height: 60,
    backgroundColor: "#152e541c",
    "& h5": {
      marginTop: -35,
      width: 175,
      textAlign: "center",
    },
  },
  heroButton: {
    alignSelf: "flex-start",
    marginTop: "20px",
    display: "inline-block",
  },
  activeLink: { 
    "&:hover": {
      cursor: "pointer",
    },
  }
});

const useMyContext = () => {
  const context = useContext(EmpdContext);
  if (!context) {
    throw new Error("No provider found for Context");
  }
  return context;
};

const AuthErrorModal = ({ className }: Props) => {
  const context = useMyContext();
  const {
	openAuthErrorDialog,
	setAuthErrorDialogOpen,
	authError,
	setAuthError,
  } = context;


  const classes = useStyles();

  const handleClick = () => {
  	setAuthError(undefined)
    setAuthErrorDialogOpen(false)
  };

  return (
    <>
      <Dialog
        open={openAuthErrorDialog}
        onClose={() => {
			setAuthError(undefined)
			setAuthErrorDialogOpen(false)
		}}
        maxWidth={"md"}
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <h3>Oops!</h3>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
			  setAuthError(undefined)
              setAuthErrorDialogOpen(false)
          }}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
			{authError && 
			parse(authError)}
        </DialogContent>
        <DialogActions>
          <Button className={`disabled`} onClick={() => handleClick()} label="Ok" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AuthErrorModal;
